import { AxiosResponse } from 'axios';
import dayjs from 'dayjs';
import React from 'react';

import { Badge, Button, Stack, Table, Text } from '@mantine/core';

import { UseMutateFunction } from '@tanstack/react-query';

import { BookingsForModerator, ITrackCarAccessRequestType } from '@/shared/types/booking.types';

import { IconCheck } from '@tabler/icons-react';

type SecurityItemProps = {
	booking: BookingsForModerator;
	someCarPass: boolean;
	someGuests: boolean;
	trackCarAccess: UseMutateFunction<
		AxiosResponse<any, any>,
		Error,
		ITrackCarAccessRequestType,
		unknown
	>;
	isTrackingCarAccess: boolean;
};

export const SecurityItem: React.FC<SecurityItemProps> = ({
	booking,
	someCarPass,
	someGuests,
	trackCarAccess,
	isTrackingCarAccess,
}) => {
	return (
		<Table.Tr>
			<Table.Td>
				<Text size="md" fw={600} lts="normal">
					{booking.fullname ?? 'Нет данных'}
				</Text>
			</Table.Td>
			<Table.Td>
				<Text size="md" c="dimmed">
					{booking.booking_object_name}
				</Text>
			</Table.Td>
			{someCarPass ? (
				<Table.Td ta="center">
					{booking?.car_number && (
						<Badge variant="light">
							<Text size="md" fw={600}>
								{booking?.car_number}
							</Text>
						</Badge>
					)}
				</Table.Td>
			) : (
				<Table.Td ta="center"></Table.Td>
			)}
			{someGuests && (
				<Table.Td ta="center">
					{booking?.guest_numbers?.length ? (
						<Stack gap={4} align="center">
							{booking.guest_numbers.map((phone) => (
								<Text key={phone} component="a" href={`tel:${phone}`} size="md" c="dimmed">
									{phone}
								</Text>
							))}
						</Stack>
					) : null}
				</Table.Td>
			)}
			<Table.Td ta="center">
				<Text size="md" c="dimmed">
					{dayjs(booking.start).format('DD MMMM HH:mm')}
				</Text>
			</Table.Td>
			<Table.Td ta="center">
				<Text size="md" c="dimmed">
					{dayjs(booking.end).format('DD MMMM HH:mm')}
				</Text>
			</Table.Td>
			<Table.Td ta="center">
				<Badge variant="light" color={booking.was_accepted ? 'green' : 'yellow'}>
					<Text size="md" fw={600}>
						{booking.was_accepted ? 'Подтверждено' : 'Не подтверждено'}
					</Text>
				</Badge>
			</Table.Td>
			<Table.Td ta="center">
				{!booking.was_accepted ? (
					<Button
						variant="light"
						size="compact-sm"
						radius="sm"
						onClick={() => {
							const params: ITrackCarAccessRequestType = {
								car_number: booking.car_number,
								booking_object_id: booking.booking_object_id,
								direction: 'in',
							};

							if (booking.booking_id) {
								params.booking_id = booking.booking_id;
							}

							trackCarAccess(params);
						}}
						loading={isTrackingCarAccess}
					>
						<IconCheck size={16} />
					</Button>
				) : (
					<IconCheck size={16} />
				)}
			</Table.Td>
		</Table.Tr>
	);
};
